import React from 'react';
import clsx from 'clsx';
import Timeline from 'Components/common/timeline';

// import { ISegmentEventData } from 'Utils/trackAppEvents';
//import { INudgeCustomCTAActions } from 'Store/nudge/types';

// import Nudge from '../nudge';
import Header from '../header';

import { ILayoutStyleProps } from './styles';
import * as Styles from './styles';
import { resolvePath } from '@/utils/resolvePath';
import { useSelector } from 'react-redux';
import { selectIsMobile } from '@/store/modules/userDataSlice';

interface ILayoutProps extends ILayoutStyleProps {
    className?: string;
    children: React.ReactElement | React.ReactElement[] | string;
    hideHeader?: boolean;
    heading?: string;
    hideHelp?: boolean;
    margin?: string;
    backURL?: string;
    showTimeline?: boolean;
    hideMobileHeader?: boolean;
    hideDesktopHeader?: boolean;
    // trackEventParams?: ISegmentEventData;
    isIST?: boolean;
    onBackClick?: () => void;
    onClick?: () => void;
    minHeight?: string;
}

export default function Layout(props: ILayoutProps) {
    const {
        className,
        children,
        display,
        justify,
        align,
        hasFixedCTA,
        hideHeader,
        heading,
        hideHelp,
        margin,
        backURL,
        // trackEventParams,
        hideMobileHeader,
        hideDesktopHeader,
        isIST,
        onBackClick,
        onClick,
        showTimeline = false,
        // nudgeCustomLinkCTAAction,
        // nudgeCustomPrimaryCTAAction,
        // nudgeCustomSecondaryCTAAction,
        minHeight,
    } = props;
    return (
        <Styles.Container
            className={clsx('layoutContainer', className)}
            display={display}
            justify={justify}
            align={align}
            hasFixedCTA={hasFixedCTA}
            onClick={onClick}
            minHeight={minHeight}
        >
            {/* <AppBarLineLoader /> */}
            {!hideHeader && (
                <Header
                    hideHelp={hideHelp}
                    margin={margin}
                    backURL={backURL}
                    //trackEventParams={trackEventParams}
                    hideMobileHeader={hideMobileHeader}
                    hideDesktopHeader={hideDesktopHeader}
                    isIST={isIST}
                    onBackClick={onBackClick}
                />
            )}
            <Styles.Wrapper
                className="layoutWrapper"
                hideMobileHeader={hideMobileHeader}
                showTimeline={showTimeline}
            >
                {heading && <Styles.PageHeading>{heading}</Styles.PageHeading>}
                <>{children}</>
            </Styles.Wrapper>
            {/* <Nudge
                nudgeCustomLinkCTAAction={nudgeCustomLinkCTAAction}
                nudgeCustomPrimaryCTAAction={nudgeCustomPrimaryCTAAction}
                nudgeCustomSecondaryCTAAction={nudgeCustomSecondaryCTAAction}
            /> */}
            {showTimeline && (
                <Styles.Timeline>
                    <Timeline />
                </Styles.Timeline>
            )}
        </Styles.Container>
    );
}

// {!isMob && (
//     <Styles.ImageWrapper>
//         <div>
//             <img
//                 src={resolvePath('/images/ad-logo-new.svg')}
//                 //width={'75%'}
//                 alt="Acko Garage"
//             />
//         </div>

//         <img
//             src={resolvePath('/images/desktop-bg.png')}
//             //width={'75%'}
//             alt="Acko Garage"
//         />
//     </Styles.ImageWrapper>
// )}
